import { Component, OnInit, ViewChild, ViewChildren, Output, EventEmitter } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { AlertComponent, EnumAlertType } from '../../../../common/component/alert/alert.component';
import { DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime';
import { CreateReverseAudit } from '../../../../core/models/CreateReverseAudit';
import { AddDaysToDate } from '../../../../core';

@Component({
  selector: 'app-rvrs-create-manual',
  templateUrl: './rvrs-create-manual.component.html',
  styleUrls: ['./rvrs-create-manual.component.scss']
})
export class RvrsCreateManualComponent implements OnInit {
  @ViewChild(AlertComponent, { static: true }) alerter: AlertComponent;
  @ViewChild('editPropertyValueTextBox', { static: false }) editPropertyValueTextBox;

  constructor() {
    let start = this.now().addYears(-1).year;
    this.contractYearList = [(start++).toString(), (start++).toString(), (start++).toString()];
  }
  contractYearList: string[] ;
  now: () => DateTime = () => DateTime.now;
  @Output() dataEntered = new EventEmitter<any>();

  rateAudit:{
    property:Array<any>,
    [key:string]:any
  };
  public gridView:GridDataResult;
  public state: State = {
    skip: 0,
    take: 5
  };
  currentlyEditingItem:any = null;
  currentlyEditingValue:string = '';
  contractYearhtml: string = this.now().addYears(0).year.toString();
  importedData:CreateReverseAudit=new CreateReverseAudit();
  dropdownPopupSettings:string = "";

  ngOnInit(){
    this.rateAudit = {
      CustomerAccountID: '',
      CustomerAccountName: '',
      contractYearhtml: '',
      auditAmadeus: true,
      auditApollo: true,
      auditGalileo: true,
      auditSabre: true,
      auditWorldspan: true,
      sabrePCC: '',
      rateAccessType: 'Corporate',
      RACFilters: '',
      property: []
    };
    this.gridView = {
      data: [],
      total: 0
    };
    this.dataEntered.emit({inputValid:false, selectedAuditID: '0'});
  }

  modelChange(event) {
    let inputValid = false;
    if(this.rateAudit.CustomerAccountID && this.rateAudit.property.length>0) {
      inputValid = true;
    }
    this.dataEntered.emit({inputValid:inputValid, selectedAuditID: '0'})
  }

  dataStateChange(state: DataStateChangeEvent) {
    this.state = state;
    this.gridView.data = [];
    let maxIndex = this.state.skip + this.state.take;
    for(let ctr=this.state.skip; ctr<maxIndex && ctr<this.rateAudit.property.length; ctr++) {
      this.gridView.data.push(this.rateAudit.property[ctr]);
    }
  }
  clickDelete(event, item) {
    event.preventDefault();
    event.stopPropagation();
    if(item==this.currentlyEditingItem) {
      this.currentlyEditingItem = null;
    }
    let index = this.rateAudit.property.indexOf(item);
    this.rateAudit.property.splice(index, 1);
    this.gridView.data = [];
    let maxIndex = this.state.skip + this.state.take;
    for(let ctr=this.state.skip; ctr<maxIndex && ctr<this.rateAudit.property.length; ctr++) {
      this.gridView.data.push(this.rateAudit.property[ctr]);
    }
    this.gridView.total = this.rateAudit.property.length;


  }
  addNewProperty($event) {
    $event.stopPropagation();
      let x,count=0;
      for(var i=0;i<this.rateAudit.property.length;i++){
         x=this.validationCheck(this.rateAudit.property[i]);
        if(x==false){
         // break;
         count++;
        }
      }

      if(count==0){
        if(this.rateAudit && this.rateAudit.property) {
        let parentTd:Element = $event.target.parentElement;
        this.currentlyEditingItem = {
          errorRow:false,
          rowdeleted:false,
          PropertyName: '',
          PropertyAddress: '',
          PropertyCity: '',
          PropertyStateProvince: '',
          PropertyPostalCode: '',
          PropertyCountry: '',
          hotelChainCode: '',
          AmadeusChainCode: '',
          amadeusPropCode: '',
          amadeusRAC: '',
          ApolloChainCode: '',
          apolloPropCode: '',
          apolloRAC: '',
          CurrencyCode:'USD', //have hard coded these values as they are required fields
          LRA:true, // for rate audit creation but not used for reverse audit(we donot accept input for these from user)
          GalileoChainCode: '',
          galileoPropCode: '',
          galileoRAC: '',
          SabreChainCode: '',
          sabrePropCode: '',
          sabreRAC: '',
          season1End:AddDaysToDate( this.now(), 91).toJsDate(),
          season1ExpectedPrice:1,
          season1Start:this.now().toJsDate(),
          WorldspanChainCode: '',
          worldspanPropCode: '',
          worldspanRAC: ''
        };
        this.rateAudit.property.splice(this.state.skip, 0, this.currentlyEditingItem);
        this.gridView.data = [];
        let maxIndex = this.state.skip + this.state.take;
        for(let ctr=this.state.skip; ctr<maxIndex && ctr<this.rateAudit.property.length; ctr++) {
          this.gridView.data.push(this.rateAudit.property[ctr]);
        }
        this.gridView.total = this.rateAudit.property.length;
        this.currentlyEditingValue = 'PropertyName';
      }
   }
  }

  setCurrentlyEditingItem($event, item:any, fieldName:string) {
    $event.stopPropagation();
    let parentTd:Element = $event.target.parentElement;
    this.currentlyEditingItem = item;
    this.currentlyEditingValue = fieldName;
    window.setTimeout(function() {
      let input = parentTd.getElementsByTagName('input')[0];
      if(input) {
        input.focus();
      }
    }, 1);
  }

  GetManualData(){
    var okToProceed=true;
    if(this.rateAudit.CustomerAccountID=='') {
      this.alerter.showAlertMessage(5000, 'Account ID required', EnumAlertType.Error);
      okToProceed=false;
    }
    else if(this.rateAudit.CustomerAccountName=='') {
      this.alerter.showAlertMessage(5000, 'Account Name required', EnumAlertType.Error);
      okToProceed=false;
    }
    else if(this.rateAudit.auditAmadeus==false && this.rateAudit.auditApollo==false &&this.rateAudit.auditSabre==false
      &&this.rateAudit.auditGalileo==false &&this.rateAudit.auditWorldspan==false) {
      this.alerter.showAlertMessage(5000, 'At least one GDS should be selected', EnumAlertType.Error);
      okToProceed=false;
    }
    else if(this.rateAudit.auditSabre==true && this.rateAudit.sabrePCC=='')
    {
      this.alerter.showAlertMessage(5000, 'Sabre PCC required', EnumAlertType.Error);
      okToProceed=false;
    }
    else{
      if(this.rateAudit.property.length==0){
        this.alerter.showAlertMessage(5000, 'At least one property required', EnumAlertType.Error);
        okToProceed=false;
      }
      else{
            for(var i=0;i<this.rateAudit.property.length;i++){
              let x=this.validationCheck(this.rateAudit.property[i]);
            if(x==false){
              okToProceed=false;
            //  break;
            }
          }
    }
  }

   if(okToProceed){
    this.rateAudit.ContractYear=this.contractYearhtml;
    return this.rateAudit;
   }
   else{
     return false;
   }


  }

  validationCheck(item){
    item.errorRow=false;
    var errorMessage="";
      if(item.PropertyName=='') {
        errorMessage="Property Name";
        item.errorRow=true;

      }
     if(item.hotelChainCode=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Hotel Chain Code";
        item.errorRow=true;

      }
     if(this.rateAudit.auditAmadeus){
      if(item.AmadeusChainCode=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Amadeus Chain Code";
        item.errorRow=true;
      }
      if(item.amadeusPropCode=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Amadeus Prop Code";
        item.errorRow=true;
      }
      if(item.amadeusRAC=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Amadeus RAC Code";
        item.errorRow=true;
      }
     }
     if(this.rateAudit.auditApollo){
      if(item.ApolloChainCode=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Apollo Chain Code";
        item.errorRow=true;
      }
      if(item.apolloPropCode=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Apollo Prop Code";
        item.errorRow=true;
      }
      if(item.apolloRAC=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Apollo RAC ";
        item.errorRow=true;
      }
     }
     if(this.rateAudit.auditGalileo){
      if(item.GalileoChainCode=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Galileo Chain Code ";
        item.errorRow=true;
      }
       if(item.galileoPropCode=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Galileo Prop Code ";
        item.errorRow=true;
      }
      if(item.galileoRAC=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Galileo RAC ";
        item.errorRow=true;
      }
     }
     if(this.rateAudit.auditSabre){
      if(item.SabreChainCode=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Sabre Chain Code ";
        item.errorRow=true;
      }
       if(item.sabrePropCode=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Sabre Prop Code ";
        item.errorRow=true;
      }
       if(item.sabreRAC=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Sabre RAC ";
        item.errorRow=true;
      }
     }
     if(this.rateAudit.auditWorldspan){
      if(item.WorldspanChainCode=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Worldspan Chain code ";
        item.errorRow=true;
      }
       if(item.worldspanPropCode=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Worldspan Prop code ";
        item.errorRow=true;
      }
       if(item.worldspanRAC=='') {
        errorMessage=errorMessage+",";
        errorMessage=errorMessage+" Worldspan RAC ";
        item.errorRow=true;
      }
     }


     var trimError= errorMessage.replace(/^,/, '');
     if(trimError!=""){
        this.alerter.showAlertMessage(5000, trimError+' is required', EnumAlertType.Error);
        return false;
     }
  }
}
